import { createConsumer } from '@rails/actioncable'

const consumers = new Map()

export const acquireConsumer = (url) => {
    if (!url) {
        return null
    }

    const existingEntry = consumers.get(url)
    if (existingEntry) {
        existingEntry.refCount += 1
        return existingEntry.consumer
    }

    const consumer = createConsumer(url)
    consumers.set(url, {
        consumer,
        refCount: 1,
    })

    return consumer
}

export const releaseConsumer = (url) => {
    if (!url) {
        return
    }

    const entry = consumers.get(url)
    if (!entry) {
        return
    }

    entry.refCount -= 1

    if (entry.refCount > 0) {
        return
    }

    entry.consumer.disconnect()
    consumers.delete(url)
}
